/** @description Позиция счетчика слайдов
 * ECounterPosition.HEADER В шапке
 */
export var ECounterPosition = /*#__PURE__*/function (ECounterPosition) {
  ECounterPosition[ECounterPosition["HEADER"] = 0] = "HEADER";
  return ECounterPosition;
}({});

/** @description Слайды для карусели
 * @param {React.ReactNode} node Содержимое слайда
 * @param {string} key Уникальный ключ
 * @param {string} key Уникальный ключ
 */

/** @description Тип аргументов для коллбека смены файлов
 * @param {number} currentSlide Порядковый номер нового слайда
 * @param {number} prevSlide Порядковый номер предыдущего слайда
 * @param {number} totalSlides Общее количество слайдов
 */

/** @description Доп. опции полноэкранного режима
 * @param {boolean} hideThumbnails Скрыть миниатюры
 * @param {ECounterPosition} counterPosition Позиция счетчика слайдов
 * @param {IContentOptions} contentOptions Параметры пользовательского контента
 */

/** @description Параметры пользовательского контента
 * @param {React.ReactNode} headerContent Контент шапки
 * @param {React.ReactNode} footerContent Контент футера
 */

/** @description Параметры счетчика элементов
 * @param {number} current Текущий элемент
 * @param {number} total Общее количество элементов
 */

/** @description Позиция курсора
 */

/** @description Интерфейс с настройками полноэкранного режима для определенного интервала ширины окна
 * @param {number} minWidth Минимальная ширина окна
 * @param {number} maxWidth Максимальная ширина окна
 * @param {IFullscreenCarouselOptions} options Настройки при ширине в интервале [minWidth, maxWidth)
 */

/** @description Событие взаимодействия с помощью мышки/тача
 */